import {
  GET_RATINGS_AND_REVIEWS_PENDING,
  GET_RATINGS_AND_REVIEWS_FAILED,
  GET_RATINGS_AND_REVIEWS_FULFILLED,
  RESET_RATINGS_AND_REVIEWS,
} from "constants-lib/actionTypes"

const initialState = {
  storeID: ``,
  getRatingsReviewsContentState: ``,
  ratingsReviewsContent: null,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_RATINGS_AND_REVIEWS:
      return {
        storeID: ``,
        getRatingsReviewsContentState: ``,
        ratingsReviewsContent: null,
      }
    case GET_RATINGS_AND_REVIEWS_FAILED:
      return {
        ...state,
        ratingsReviewsContent: null,
        getRatingsReviewsContentState: `failed`,
      }
    case GET_RATINGS_AND_REVIEWS_FULFILLED:
      return {
        ...state,
        ratingsReviewsContent: action.payload,
        getRatingsReviewsContentState: `fulfilled`,
      }
    case GET_RATINGS_AND_REVIEWS_PENDING:
      return {
        ...state,
        storeID: action.payload,
        getRatingsReviewsContentState: `pending`,
      }
    default:
      return state
  }
}
